export default "assets/images/text_circle_dark-ae24f110.png";